$(document).on("click", ".question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title').removeClass('active');
    jQuery('.question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});





 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });








/* 5TRIP jump links: null-safe, offset for sticky header, all offer CTAs go to #5trip-offer */
(function () {
  function t5HeaderOffset() {
    var h = 0;
    document.querySelectorAll('header, .shopify-section-group-header-group, [id*="header_group_pdp"], .t5-nav, .custom_header').forEach(function (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      var stays = cs.position === 'fixed' || (cs.position === 'sticky' && el.parentElement && el.parentElement.offsetHeight > window.innerHeight * 2);
      if (stays && r.height > 0 && r.height < 200 && r.top <= 1 && r.bottom > h) h = r.bottom;
    });
    return h;
  }
  function t5ScrollTo(el) {
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - t5HeaderOffset() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    return true;
  }
  function t5Offer() {
    return document.getElementById('5trip-offer') || document.querySelector('.landing_page_product') || document.getElementById('5trip-bundle');
  }
  window.t5ScrollTo = t5ScrollTo;
  window.t5Offer = t5Offer;

  $(document).on('click', 'a[href]', function (e) {
    var raw = this.getAttribute('href') || '';
    var url;
    try { url = new URL(raw, location.href); } catch (err) { return; }
    var offer = document.getElementById('5trip-offer');
    var sameHost = url.host === location.host || /(^|\.)the5trip\.com$/.test(url.host);
    var hash = url.hash ? decodeURIComponent(url.hash.slice(1)) : '';

    /* plain "#" links: offer section if present, otherwise do nothing */
    if (raw === '#') { e.preventDefault(); t5ScrollTo(t5Offer()); return; }

    /* same-page hash links (#reviews, #faq, #work ...): guard against missing targets */
    if (raw.charAt(0) === '#') {
      var tgt = null;
      if (hash === 'work' && window.innerWidth > 768) tgt = document.querySelector('.pdp_reasons_section.desktop_only');
      tgt = tgt || document.getElementById(hash);
      if (hash === '5trip-bundle' || hash === '5trip-offer') tgt = t5Offer();
      e.preventDefault();
      t5ScrollTo(tgt);
      return;
    }

    /* one-page home: links to the offer or the product page stay on this page */
    if (offer && sameHost && !this.target) {
      var isOffer = hash === '5trip-offer' || hash === '5trip-bundle';
      var isProduct = /^\/products\//.test(url.pathname) && url.pathname.indexOf('/tools/') !== 0;
      var isHome = url.pathname === '/' || url.pathname === '';
      if (isOffer || isProduct || (isHome && hash)) {
        e.preventDefault();
        var t = (!isOffer && hash) ? document.getElementById(hash) : null;
        t5ScrollTo(t || offer);
      }
    }
  });
})();



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('start_count');
  $block.find('.count_js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.custom_counter .icons_with_text_flex').each(function () {
    const $block = $(this);
    if ($block.hasClass('start_count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);




$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.product_slider_custom_slider_button a.custom_hk_button, .ajax_add_cart, .custom_ajax_atc', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
    if (typeof window.refreshAndOpenCartDrawer === 'function') {
      window.refreshAndOpenCartDrawer().always(function () {
        this_element.removeClass('loading_hk');
      });
    } else {
      window.location.href = '/cart';
    }
 } 
 });
  });



   $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.pdp_week_list1 .icons_with_text_flex .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});



$(document).on("click", 'a[href="#ingredients"]', function (e) {
 e.preventDefault(); 
$('.custom_popup').css('display','flex');
});



$(document).on("click", '.close_popup', function (e) {
 e.preventDefault(); 
$('.custom_popup').hide();
});

// CLOSE POPUP ON OUTSIDE CLICK
$(document).on('click', '.custom_popup', function(e) {

  // If click is INSIDE .custom_popup OR .icon_with_text_flex → DO NOTHING
  if (
    $(e.target).closest('.icon_with_text_flex').length > 0
  ) {
    return;
  }

  // Otherwise → close popup
  $('span.close_popup').trigger('click');
});





$(document).on("click", 'a[href="#show"]', function (e) {
  e.preventDefault();
  $('.show_js').hide();
  $('.hide_js').show();
  $('.pdp_review3_section .review_slider_main_slider_new .review_slider_custom_slider_new_item:nth-child(3)~*').show();
});

$(document).on("click", 'a[href="#hide"]', function (e) {
  e.preventDefault();
  $('.show_js').show();
  $('.hide_js').hide();
  $('.pdp_review3_section .review_slider_main_slider_new .review_slider_custom_slider_new_item:nth-child(3)~*').hide();
});


$(document).on("click", "a[href='#popup']", function (e) {
  e.preventDefault();
$('.custom_popup_hp').css('display','flex').addClass('active');
});
$(document).on("click", ".custom_close_hp_popup", function (e) {
  e.preventDefault();
$('.custom_popup_hp').css('display','none').removeClass('active');
});